import React from "react";
import { Modal, Button, Form, Input, Typography } from "antd";
import {
  UserOutlined,
  MailOutlined,
  LockOutlined,
  GoogleOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const AuthModal = ({
  authModalVisible,
  handleAuthModalCancel,
  isSignUp,
  authLoading,
  form,
  handleEmailAuth,
  handleGoogleAuth,
  switchAuthMode,
  themeColor,
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: "center" }}>
          <UserAddOutlined
            style={{
              fontSize: "24px",
              color: themeColor,
              marginRight: "8px",
            }}
          />
          {isSignUp ? "Create Your Account" : "Sign In to Yalla Nellab"}
        </div>
      }
      open={authModalVisible}
      onCancel={handleAuthModalCancel}
      footer={null}
      width={400}
      styles={{
        body: { padding: "20px" },
      }}
    >
      <Button
        icon={<GoogleOutlined />}
        size="large"
        block
        style={{
          marginBottom: 20,
          backgroundColor: "#4285F4",
          color: "white",
          border: "none",
        }}
        onClick={handleGoogleAuth}
        loading={authLoading}
      >
        {isSignUp ? "Sign Up with Google" : "Sign In with Google"}
      </Button>

      <div style={{ textAlign: "center", margin: "15px 0" }}>
        <Text type="secondary">
          OR {isSignUp ? "SIGN UP" : "SIGN IN"} WITH EMAIL
        </Text>
      </div>

      <Form
        form={form}
        name="auth"
        onFinish={handleEmailAuth}
        layout="vertical"
      >
        {isSignUp && (
          <Form.Item
            name="displayName"
            rules={[{ required: true, message: "Please input your Name!" }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Full Name"
              size="large"
            />
          </Form.Item>
        )}

        <Form.Item
          name="email"
          rules={[
            { required: true, message: "Please input your Email!" },
            { type: "email", message: "The input is not valid E-mail!" },
          ]}
        >
          <Input prefix={<MailOutlined />} placeholder="Email" size="large" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            { required: true, message: "Please input your Password!" },
            isSignUp
              ? { min: 6, message: "Password must be at least 6 characters." }
              : {},
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Password"
            size="large"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={authLoading}
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
          >
            {isSignUp ? "Sign Up" : "Sign In"}
          </Button>
        </Form.Item>
      </Form>

      <div style={{ textAlign: "center" }}>
        <Text>
          {isSignUp ? "Already have an account?" : "Don't have an account?"}{" "}
          <Button
            type="link"
            onClick={switchAuthMode}
            style={{ padding: 0, color: themeColor }}
          >
            {isSignUp ? "Sign In" : "Sign Up"}
          </Button>
        </Text>
      </div>
    </Modal>
  );
};

export default AuthModal;